import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import { ThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import './index.css';
import { App } from './App';
import colors from "./colors.js";

let theme = createMuiTheme({
  spacing: 8,
  palette: {
    background: {
      default: colors.blue,
    }
  },
  typography: {
    fontFamily: [
      'futura',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(241, 243, 244, 0.4)"
      }
    },
    MuiListItemIcon: {
      root: {
        color: colors.blue,
        cursor: "pointer",
      }
    },
    MuiSvgIcon: {
      root: {
        color: colors.blue,
      }
    }
  },
  MuiButtonBase: {
    // The properties to apply
    disableRipple: true, // No more ripple, on the whole application 💣!
  },
});
theme = responsiveFontSizes(theme, {factor: 2.75});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <CssBaseline />
      <App />
    </React.StrictMode>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
